import React from 'react';
import '../CartSidebar/CartSidebar.css'; 

const SelfCart = ({ isOpen, closeSidebar }) => {
  return (
    <div className={`cart-sidebar ${isOpen ? 'open' : ''}`}>
      <div className="cart-sidebar-header">
        <h2 className='header'>Your Cart</h2>
        <button className="close-cart-btn" onClick={closeSidebar}>
          &times;
        </button>
      </div>
      <div className="cart-items">
        <p>No items in cart yet.</p>
      </div>
      <div className="cart-sidebar-footer">
        <button className="checkout-btn">Proceed to Checkout</button>
      </div>
    </div>
  );
};

export default SelfCart;
